module.exports = __webpack_public_path__ + "img/3-(5).28f13340.jpg";